// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AccessReviewByAccessConflictsService } from "./accessreview";
import type { AccessReviewSetScopeByAccessConflictResponse } from "./accessreview";
import type { AccessReviewSetScopeByAccessConflictRequest } from "./accessreview";
import type { AccessReviewByAccessConflictsServiceListResponse } from "./accessreview";
import type { AccessReviewByAccessConflictsServiceListRequest } from "./accessreview";
import { AccessReviewConnectorSourceService } from "./accessreview";
import type { AccessReviewConnectorSourceOutdatedSearchResponse } from "./accessreview";
import type { AccessReviewConnectorSourceOutdatedSearchRequest } from "./accessreview";
import type { AccessReviewConnectorSourceSearchResponse } from "./accessreview";
import type { AccessReviewConnectorSourceSearchRequest } from "./accessreview";
import type { AccessReviewConnectorSourceServiceListOutdatedResponse } from "./accessreview";
import type { AccessReviewConnectorSourceServiceListOutdatedRequest } from "./accessreview";
import type { AccessReviewConnectorSourceListResponse } from "./accessreview";
import type { AccessReviewConnectorSourceListRequest } from "./accessreview";
import { AccessReviewTemplateService } from "./accessreview";
import type { AccessReviewTemplateSetScopeByAccessConflictResponse } from "./accessreview";
import type { AccessReviewTemplateSetScopeByAccessConflictRequest } from "./accessreview";
import type { AccessReviewTemplateByAccessConflictsServiceListResponse } from "./accessreview";
import type { AccessReviewTemplateByAccessConflictsServiceListRequest } from "./accessreview";
import type { AccessReviewTemplateSearchResourceTypeRollupSearchResponse } from "./accessreview";
import type { AccessReviewTemplateSearchResourceTypeRollupSearchRequest } from "./accessreview";
import type { AccessReviewTemplateResourceRollupSearchResponse } from "./accessreview";
import type { AccessReviewTemplateResourceRollupSearchRequest } from "./accessreview";
import type { AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse } from "./accessreview";
import type { AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest } from "./accessreview";
import type { AccessReviewTemplateServiceListAccessReviewsResponse } from "./accessreview";
import type { AccessReviewTemplateServiceListAccessReviewsRequest } from "./accessreview";
import type { AccessReviewTemplateServiceUpdateResponse } from "./accessreview";
import type { AccessReviewTemplateServiceUpdateRequest } from "./accessreview";
import type { AccessReviewTemplateServiceSearchOwnersResponse } from "./accessreview";
import type { AccessReviewTemplateServiceSearchOwnersRequest } from "./accessreview";
import type { AccessReviewTemplateServiceSetOwnersResponse } from "./accessreview";
import type { AccessReviewTemplateServiceSetOwnersRequest } from "./accessreview";
import type { AccessReviewTemplateServiceListOwnersResponse } from "./accessreview";
import type { AccessReviewTemplateServiceListOwnersRequest } from "./accessreview";
import type { AccessReviewTemplateServiceGetResponse } from "./accessreview";
import type { AccessReviewTemplateServiceGetRequest } from "./accessreview";
import type { AccessReviewTemplateServiceSearchResponse } from "./accessreview";
import type { AccessReviewTemplateServiceSearchRequest } from "./accessreview";
import type { AccessReviewTemplateServiceListResponse } from "./accessreview";
import type { AccessReviewTemplateServiceListRequest } from "./accessreview";
import type { AccessReviewTemplateServiceDeleteResponse } from "./accessreview";
import type { AccessReviewTemplateServiceDeleteRequest } from "./accessreview";
import type { AccessReviewTemplateServiceCreateResponse } from "./accessreview";
import type { AccessReviewTemplateServiceCreateRequest } from "./accessreview";
import { AccessReviewEntitlementPreviewService } from "./accessreview";
import type { AccessReviewEntitlementPreviewServiceSearchResponse } from "./accessreview";
import type { AccessReviewEntitlementPreviewServiceSearchRequest } from "./accessreview";
import { AccessReviewReportService } from "./accessreview";
import type { AccessReviewReportServiceListResponse } from "./accessreview";
import type { AccessReviewReportServiceListRequest } from "./accessreview";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AccessReviewService } from "./accessreview";
import type { AccessReviewServiceDeleteResponse } from "./accessreview";
import type { AccessReviewServiceDeleteRequest } from "./accessreview";
import type { AccessReviewServiceListEntitlementsWithMultiAppResponse } from "./accessreview";
import type { AccessReviewServiceListEntitlementsWithMultiAppRequest } from "./accessreview";
import type { AccessReviewServiceListResponse } from "./accessreview";
import type { AccessReviewServiceListRequest } from "./accessreview";
import type { AccessReviewServiceUpdateResponse } from "./accessreview";
import type { AccessReviewServiceUpdateRequest } from "./accessreview";
import type { AccessReviewServiceCreateResponse } from "./accessreview";
import type { AccessReviewServiceCreateRequest } from "./accessreview";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AccessReviewServiceGetResponse } from "./accessreview";
import type { AccessReviewServiceGetRequest } from "./accessreview";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewService
 */
export interface IAccessReviewServiceClient {
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: AccessReviewServiceGetRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceGetRequest, AccessReviewServiceGetResponse>;
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: AccessReviewServiceCreateRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceCreateRequest, AccessReviewServiceCreateResponse>;
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: AccessReviewServiceUpdateRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceUpdateRequest, AccessReviewServiceUpdateResponse>;
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AccessReviewServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceListRequest, AccessReviewServiceListResponse>;
    /**
     * @generated from protobuf rpc: ListEntitlementsWithMultiApp
     */
    listEntitlementsWithMultiApp(input: AccessReviewServiceListEntitlementsWithMultiAppRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceListEntitlementsWithMultiAppRequest, AccessReviewServiceListEntitlementsWithMultiAppResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: AccessReviewServiceDeleteRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceDeleteRequest, AccessReviewServiceDeleteResponse>;
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewService
 */
export class AccessReviewServiceClient implements IAccessReviewServiceClient, ServiceInfo {
    typeName = AccessReviewService.typeName;
    methods = AccessReviewService.methods;
    options = AccessReviewService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: AccessReviewServiceGetRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceGetRequest, AccessReviewServiceGetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewServiceGetRequest, AccessReviewServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: AccessReviewServiceCreateRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceCreateRequest, AccessReviewServiceCreateResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewServiceCreateRequest, AccessReviewServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: AccessReviewServiceUpdateRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceUpdateRequest, AccessReviewServiceUpdateResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewServiceUpdateRequest, AccessReviewServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AccessReviewServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceListRequest, AccessReviewServiceListResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewServiceListRequest, AccessReviewServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListEntitlementsWithMultiApp
     */
    listEntitlementsWithMultiApp(input: AccessReviewServiceListEntitlementsWithMultiAppRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceListEntitlementsWithMultiAppRequest, AccessReviewServiceListEntitlementsWithMultiAppResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewServiceListEntitlementsWithMultiAppRequest, AccessReviewServiceListEntitlementsWithMultiAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: AccessReviewServiceDeleteRequest, options?: RpcOptions): UnaryCall<AccessReviewServiceDeleteRequest, AccessReviewServiceDeleteResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewServiceDeleteRequest, AccessReviewServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewReportService
 */
export interface IAccessReviewReportServiceClient {
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AccessReviewReportServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewReportServiceListRequest, AccessReviewReportServiceListResponse>;
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewReportService
 */
export class AccessReviewReportServiceClient implements IAccessReviewReportServiceClient, ServiceInfo {
    typeName = AccessReviewReportService.typeName;
    methods = AccessReviewReportService.methods;
    options = AccessReviewReportService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AccessReviewReportServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewReportServiceListRequest, AccessReviewReportServiceListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewReportServiceListRequest, AccessReviewReportServiceListResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewEntitlementPreviewService
 */
export interface IAccessReviewEntitlementPreviewServiceClient {
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: AccessReviewEntitlementPreviewServiceSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewEntitlementPreviewServiceSearchRequest, AccessReviewEntitlementPreviewServiceSearchResponse>;
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewEntitlementPreviewService
 */
export class AccessReviewEntitlementPreviewServiceClient implements IAccessReviewEntitlementPreviewServiceClient, ServiceInfo {
    typeName = AccessReviewEntitlementPreviewService.typeName;
    methods = AccessReviewEntitlementPreviewService.methods;
    options = AccessReviewEntitlementPreviewService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: AccessReviewEntitlementPreviewServiceSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewEntitlementPreviewServiceSearchRequest, AccessReviewEntitlementPreviewServiceSearchResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewEntitlementPreviewServiceSearchRequest, AccessReviewEntitlementPreviewServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewTemplateService
 */
export interface IAccessReviewTemplateServiceClient {
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: AccessReviewTemplateServiceCreateRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceCreateRequest, AccessReviewTemplateServiceCreateResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: AccessReviewTemplateServiceDeleteRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceDeleteRequest, AccessReviewTemplateServiceDeleteResponse>;
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AccessReviewTemplateServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceListRequest, AccessReviewTemplateServiceListResponse>;
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: AccessReviewTemplateServiceSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceSearchRequest, AccessReviewTemplateServiceSearchResponse>;
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: AccessReviewTemplateServiceGetRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceGetRequest, AccessReviewTemplateServiceGetResponse>;
    /**
     * @generated from protobuf rpc: ListOwners
     */
    listOwners(input: AccessReviewTemplateServiceListOwnersRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceListOwnersRequest, AccessReviewTemplateServiceListOwnersResponse>;
    /**
     * @generated from protobuf rpc: SetOwners
     */
    setOwners(input: AccessReviewTemplateServiceSetOwnersRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceSetOwnersRequest, AccessReviewTemplateServiceSetOwnersResponse>;
    /**
     * @generated from protobuf rpc: SearchOwners
     */
    searchOwners(input: AccessReviewTemplateServiceSearchOwnersRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceSearchOwnersRequest, AccessReviewTemplateServiceSearchOwnersResponse>;
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: AccessReviewTemplateServiceUpdateRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceUpdateRequest, AccessReviewTemplateServiceUpdateResponse>;
    /**
     * @generated from protobuf rpc: ListAccessReviews
     */
    listAccessReviews(input: AccessReviewTemplateServiceListAccessReviewsRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceListAccessReviewsRequest, AccessReviewTemplateServiceListAccessReviewsResponse>;
    /**
     * @generated from protobuf rpc: CreateAccessReviewFromTemplate
     */
    createAccessReviewFromTemplate(input: AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest, AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse>;
    /**
     * @generated from protobuf rpc: SearchTemplateResourceRollup
     */
    searchTemplateResourceRollup(input: AccessReviewTemplateResourceRollupSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateResourceRollupSearchRequest, AccessReviewTemplateResourceRollupSearchResponse>;
    /**
     * @generated from protobuf rpc: SearchTemplateResourceTypeRollup
     */
    searchTemplateResourceTypeRollup(input: AccessReviewTemplateSearchResourceTypeRollupSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateSearchResourceTypeRollupSearchRequest, AccessReviewTemplateSearchResourceTypeRollupSearchResponse>;
    /**
     * @generated from protobuf rpc: ListAccessConflicts
     */
    listAccessConflicts(input: AccessReviewTemplateByAccessConflictsServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateByAccessConflictsServiceListRequest, AccessReviewTemplateByAccessConflictsServiceListResponse>;
    /**
     * @generated from protobuf rpc: SetTemplateCampaignScopeByAccessConflict
     */
    setTemplateCampaignScopeByAccessConflict(input: AccessReviewTemplateSetScopeByAccessConflictRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateSetScopeByAccessConflictRequest, AccessReviewTemplateSetScopeByAccessConflictResponse>;
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewTemplateService
 */
export class AccessReviewTemplateServiceClient implements IAccessReviewTemplateServiceClient, ServiceInfo {
    typeName = AccessReviewTemplateService.typeName;
    methods = AccessReviewTemplateService.methods;
    options = AccessReviewTemplateService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: AccessReviewTemplateServiceCreateRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceCreateRequest, AccessReviewTemplateServiceCreateResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateServiceCreateRequest, AccessReviewTemplateServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: AccessReviewTemplateServiceDeleteRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceDeleteRequest, AccessReviewTemplateServiceDeleteResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateServiceDeleteRequest, AccessReviewTemplateServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AccessReviewTemplateServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceListRequest, AccessReviewTemplateServiceListResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateServiceListRequest, AccessReviewTemplateServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: AccessReviewTemplateServiceSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceSearchRequest, AccessReviewTemplateServiceSearchResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateServiceSearchRequest, AccessReviewTemplateServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: AccessReviewTemplateServiceGetRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceGetRequest, AccessReviewTemplateServiceGetResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateServiceGetRequest, AccessReviewTemplateServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListOwners
     */
    listOwners(input: AccessReviewTemplateServiceListOwnersRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceListOwnersRequest, AccessReviewTemplateServiceListOwnersResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateServiceListOwnersRequest, AccessReviewTemplateServiceListOwnersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetOwners
     */
    setOwners(input: AccessReviewTemplateServiceSetOwnersRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceSetOwnersRequest, AccessReviewTemplateServiceSetOwnersResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateServiceSetOwnersRequest, AccessReviewTemplateServiceSetOwnersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchOwners
     */
    searchOwners(input: AccessReviewTemplateServiceSearchOwnersRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceSearchOwnersRequest, AccessReviewTemplateServiceSearchOwnersResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateServiceSearchOwnersRequest, AccessReviewTemplateServiceSearchOwnersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: AccessReviewTemplateServiceUpdateRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceUpdateRequest, AccessReviewTemplateServiceUpdateResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateServiceUpdateRequest, AccessReviewTemplateServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAccessReviews
     */
    listAccessReviews(input: AccessReviewTemplateServiceListAccessReviewsRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceListAccessReviewsRequest, AccessReviewTemplateServiceListAccessReviewsResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateServiceListAccessReviewsRequest, AccessReviewTemplateServiceListAccessReviewsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateAccessReviewFromTemplate
     */
    createAccessReviewFromTemplate(input: AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest, AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest, AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchTemplateResourceRollup
     */
    searchTemplateResourceRollup(input: AccessReviewTemplateResourceRollupSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateResourceRollupSearchRequest, AccessReviewTemplateResourceRollupSearchResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateResourceRollupSearchRequest, AccessReviewTemplateResourceRollupSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchTemplateResourceTypeRollup
     */
    searchTemplateResourceTypeRollup(input: AccessReviewTemplateSearchResourceTypeRollupSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateSearchResourceTypeRollupSearchRequest, AccessReviewTemplateSearchResourceTypeRollupSearchResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateSearchResourceTypeRollupSearchRequest, AccessReviewTemplateSearchResourceTypeRollupSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAccessConflicts
     */
    listAccessConflicts(input: AccessReviewTemplateByAccessConflictsServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateByAccessConflictsServiceListRequest, AccessReviewTemplateByAccessConflictsServiceListResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateByAccessConflictsServiceListRequest, AccessReviewTemplateByAccessConflictsServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetTemplateCampaignScopeByAccessConflict
     */
    setTemplateCampaignScopeByAccessConflict(input: AccessReviewTemplateSetScopeByAccessConflictRequest, options?: RpcOptions): UnaryCall<AccessReviewTemplateSetScopeByAccessConflictRequest, AccessReviewTemplateSetScopeByAccessConflictResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewTemplateSetScopeByAccessConflictRequest, AccessReviewTemplateSetScopeByAccessConflictResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewConnectorSourceService
 */
export interface IAccessReviewConnectorSourceServiceClient {
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AccessReviewConnectorSourceListRequest, options?: RpcOptions): UnaryCall<AccessReviewConnectorSourceListRequest, AccessReviewConnectorSourceListResponse>;
    /**
     * @generated from protobuf rpc: ListAllOutdatedConnectorSources
     */
    listAllOutdatedConnectorSources(input: AccessReviewConnectorSourceServiceListOutdatedRequest, options?: RpcOptions): UnaryCall<AccessReviewConnectorSourceServiceListOutdatedRequest, AccessReviewConnectorSourceServiceListOutdatedResponse>;
    /**
     * @generated from protobuf rpc: SearchAccessReviewConnectorSources
     */
    searchAccessReviewConnectorSources(input: AccessReviewConnectorSourceSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewConnectorSourceSearchRequest, AccessReviewConnectorSourceSearchResponse>;
    /**
     * @generated from protobuf rpc: SearchOutdatedAccessReviewConnectorSources
     */
    searchOutdatedAccessReviewConnectorSources(input: AccessReviewConnectorSourceOutdatedSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewConnectorSourceOutdatedSearchRequest, AccessReviewConnectorSourceOutdatedSearchResponse>;
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewConnectorSourceService
 */
export class AccessReviewConnectorSourceServiceClient implements IAccessReviewConnectorSourceServiceClient, ServiceInfo {
    typeName = AccessReviewConnectorSourceService.typeName;
    methods = AccessReviewConnectorSourceService.methods;
    options = AccessReviewConnectorSourceService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AccessReviewConnectorSourceListRequest, options?: RpcOptions): UnaryCall<AccessReviewConnectorSourceListRequest, AccessReviewConnectorSourceListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewConnectorSourceListRequest, AccessReviewConnectorSourceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAllOutdatedConnectorSources
     */
    listAllOutdatedConnectorSources(input: AccessReviewConnectorSourceServiceListOutdatedRequest, options?: RpcOptions): UnaryCall<AccessReviewConnectorSourceServiceListOutdatedRequest, AccessReviewConnectorSourceServiceListOutdatedResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewConnectorSourceServiceListOutdatedRequest, AccessReviewConnectorSourceServiceListOutdatedResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAccessReviewConnectorSources
     */
    searchAccessReviewConnectorSources(input: AccessReviewConnectorSourceSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewConnectorSourceSearchRequest, AccessReviewConnectorSourceSearchResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewConnectorSourceSearchRequest, AccessReviewConnectorSourceSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchOutdatedAccessReviewConnectorSources
     */
    searchOutdatedAccessReviewConnectorSources(input: AccessReviewConnectorSourceOutdatedSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewConnectorSourceOutdatedSearchRequest, AccessReviewConnectorSourceOutdatedSearchResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewConnectorSourceOutdatedSearchRequest, AccessReviewConnectorSourceOutdatedSearchResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewByAccessConflictsService
 */
export interface IAccessReviewByAccessConflictsServiceClient {
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AccessReviewByAccessConflictsServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewByAccessConflictsServiceListRequest, AccessReviewByAccessConflictsServiceListResponse>;
    /**
     * @generated from protobuf rpc: SetCampaignScopeByAccessConflict
     */
    setCampaignScopeByAccessConflict(input: AccessReviewSetScopeByAccessConflictRequest, options?: RpcOptions): UnaryCall<AccessReviewSetScopeByAccessConflictRequest, AccessReviewSetScopeByAccessConflictResponse>;
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewByAccessConflictsService
 */
export class AccessReviewByAccessConflictsServiceClient implements IAccessReviewByAccessConflictsServiceClient, ServiceInfo {
    typeName = AccessReviewByAccessConflictsService.typeName;
    methods = AccessReviewByAccessConflictsService.methods;
    options = AccessReviewByAccessConflictsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AccessReviewByAccessConflictsServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewByAccessConflictsServiceListRequest, AccessReviewByAccessConflictsServiceListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewByAccessConflictsServiceListRequest, AccessReviewByAccessConflictsServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetCampaignScopeByAccessConflict
     */
    setCampaignScopeByAccessConflict(input: AccessReviewSetScopeByAccessConflictRequest, options?: RpcOptions): UnaryCall<AccessReviewSetScopeByAccessConflictRequest, AccessReviewSetScopeByAccessConflictResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSetScopeByAccessConflictRequest, AccessReviewSetScopeByAccessConflictResponse>("unary", this._transport, method, opt, input);
    }
}
